import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import Landing    from "./pages/Landing";
import OrderPage  from "./pages/OrderPage";
import AdminPage  from "./pages/AdminPage";
import Profile    from "./Profile";
import { DEFAULT_PRICE, PRICE_DOC_PATH } from "./utils/constants";

/* Reads the live price from Firestore settings doc.
   Falls back to DEFAULT_PRICE if doc doesn't exist yet. */
async function fetchLivePrice() {
  try {
    const snap = await getDoc(doc(db, PRICE_DOC_PATH.col, PRICE_DOC_PATH.docId));
    if (snap.exists()) {
      const val = snap.data()[PRICE_DOC_PATH.field];
      if (typeof val === "number" && val > 0) return val;
    }
  } catch (_) {}
  return DEFAULT_PRICE;
}

function Home({ price, priceLoading }) {
  const [page, setPage] = useState("landing");
  if (page === "order") return <OrderPage onBack={() => setPage("landing")} price={price} />;
  return <Landing onStart={() => setPage("order")} price={price} priceLoading={priceLoading} />;
}

export default function App() {
  const [price, setPrice]           = useState(DEFAULT_PRICE);
  const [priceLoading, setPriceLoading] = useState(true);

  useEffect(() => {
    fetchLivePrice().then(p => { setPrice(p); setPriceLoading(false); });
  }, []);

  return (
    <Routes>
      <Route path="/"           element={<Home price={price} priceLoading={priceLoading} />} />
      <Route path="/profile/:id" element={<Profile />} />
      <Route path="/adminHoop"  element={<AdminPage onPriceChange={setPrice} />} />
    </Routes>
  );
}
